/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentEventFormModalDeleteEvent: "shipment-event-form-modal-delete-event",
  shipmentEventFormModalCancel: "shipment-event-form-modal-cancel",
  shipmentEventFormModalSave: "shipment-event-form-modal-save",
} as const;
